<template>
  <div class="not-found">
    <div>
      <img src="../assets/404.png" alt="" width="430px" height="222px" />
    </div>
    <div class="tip">
      <h1>很抱歉，您没有权限访问该页面！</h1>
      <el-button type="primary" size="small" @click="$router.go(-1)"
        >返回上一页</el-button
      >
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.not-found {
  display: flex;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%);
  margin-left: -313px;
  .tip{
    margin-left: 30px
  }
  h1 {
    margin-top: 50px;
    margin-bottom: 20px;
    font-size: 16px;
  }
}
</style>
